{
  "CANNED_MGMT": {
    "HEADER": "תגובות מוכנות",
    "LEARN_MORE": "למד עוד על תגובות שמורות",
    "DESCRIPTION": "תגובות מוכנות הן תבניות תשובה כתובות מראש שמסייעות לך להגיב במהירות לשיחה. סוכנים יכולים להקליד את התו '/' ואחריו קוד מקוצר כדי להכניס תגובה מוכנה במהלך השיחה. ",
    "COUNT": "{n} canned response | {n} canned responses",
    "HEADER_BTN_TXT": "הוסף תגובה שמורה",
    "LOADING": "מאחזר תגובות שמורות...",
    "SEARCH_PLACEHOLDER": "Search canned responses...",
    "NO_RESULTS": "No canned responses found matching your search",
    "SEARCH_404": "אין פריטים התואמים לשאילתה זו.",
    "LIST": {
      "404": "אין תגובות מוכנות זמינות בחשבון זה.",
      "TITLE": "נהל תגובות מוכנות",
      "DESC": "תגובות שמורות הן תבניות תגובה מוגדרות מראש שניתן להשתמש בהן כדי לשלוח תגובות מהירות לשיחות.",
      "TABLE_HEADER": {
        "SHORT_CODE": "קוד מקוצר",
        "CONTENT": "תוכן",
        "ACTIONS": "פעולות"
      }
    },
    "ADD": {
      "TITLE": "הוסף תגובה שמורה",
      "DESC": "תגובות שמורות הן תבניות תגובה מוגדרות מראש שניתן להשתמש בהן כדי לשלוח תגובות מהירות לשיחות.",
      "CANCEL_BUTTON_TEXT": "ביטול",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "קוד מקוצר",
          "PLACEHOLDER": "אנא הזן קוד מקוצר.",
          "ERROR": "קוד מקוצר נדרש."
        },
        "CONTENT": {
          "LABEL": "הודעה",
          "PLACEHOLDER": "אנא כתוב את ההודעה שברצונך לשמור כתבנית לשימוש מאוחר יותר.",
          "ERROR": "הודעה נדרשת."
        },
        "SUBMIT": "שלח"
      },
      "API": {
        "SUCCESS_MESSAGE": "תגובה שמורה נוספה בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      }
    },
    "EDIT": {
      "TITLE": "ערוך תגובה שמורה",
      "CANCEL_BUTTON_TEXT": "ביטול",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "קוד מקוצר",
          "PLACEHOLDER": "אנא הזן קוד מקוצר.",
          "ERROR": "קוד מקוצר נדרש."
        },
        "CONTENT": {
          "LABEL": "הודעה",
          "PLACEHOLDER": "אנא כתוב את ההודעה שברצונך לשמור כתבנית לשימוש מאוחר יותר.",
          "ERROR": "הודעה שדה חובה."
        },
        "SUBMIT": "שלח"
      },
      "BUTTON_TEXT": "ערוך",
      "API": {
        "SUCCESS_MESSAGE": "התגובה השמורה עודכנה בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "מחק",
      "API": {
        "SUCCESS_MESSAGE": "התגובה השמורה נמחקה בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      },
      "CONFIRM": {
        "TITLE": "אשר מחיקה",
        "MESSAGE": "האם אתה בטוח שברצונך למחוק ",
        "YES": "כן, מחק ",
        "NO": "לא, השאר "
      }
    }
  }
}
